import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import BrowserNavigationBar from './components/BrowserNavigationBar';
import OSXHeader from './components/OSHeader';

export default function Preview(props: PropsWithChildren) {
	return (
		<Box
			transformOrigin="top left"
			w="400%"
			h="400%"
			transform={{
				base: 'scale(0.25)',
			}}
			borderRadius="md"
			overflow="hidden"
			boxShadow={{
				base: 'md',
			}}
			position="relative"
			backgroundColor="white"
			display="grid"
			gridTemplateRows="auto auto 1fr"
		>
			<OSXHeader />
			<BrowserNavigationBar />
			{props.children}
		</Box>
	);
}
